// Simple socket.io client (Phase 5 Real-time Core)
import { io } from 'socket.io-client';

let socket;
export function initRealtime(token) {
  if (socket) return socket;
  socket = io(import.meta.env.VITE_API_WS_URL || window.location.origin, {
    path: '/ws',
    transports: ['websocket'],
    auth: { token }
  });
  return socket;
}
export function getSocket() { return socket; }
